import {getBraintreePaypalClientId} from '@stubhub/braintree-web-utils';

import {fetchBraintreeData} from './braintree';

/**
 * Returns an object with braintree token (btToken) and paypal client id (paypalClientId)
 * If some error happens, the error is returned in the `error` field
 * @param {String} host host to use in requests
 * @param {String} currencyCode currency to set in braintree
 * @param {String} eventCountry event country
 * @returns an object with `btToken` and `paypalClientId` or `error` with the error details
 */
export const initializePaypal = async (host, currencyCode, eventCountry) => {
  const {btToken, braintree, error} = (await fetchBraintreeData(host, currencyCode, eventCountry)) || {};
  if (error) {
    return {error};
  } else if (btToken && braintree) {
    const paypalClientId = await getBraintreePaypalClientId(braintree);
    if (paypalClientId && paypalClientId.error) {
      return {error: paypalClientId.error};
    } else if (paypalClientId) {
      return {btToken, paypalClientId};
    }
  }

  return {error: true};
};

const PAYLATER_ELIGIBLE_CURRENCIES = ['USD', 'EUR', 'GBP'];

/**
 * Checks if the given currency is eligible for paypal pay later
 * @param {string} currency the currency
 * @returns true if the currency is eligible for pay later, false otherwise
 */
export const isCurrencyEligibleForPayLater = (currency) => PAYLATER_ELIGIBLE_CURRENCIES.includes(currency);
